// Booking a known instructor again (#301).
//
// The rebook section lists instructors the student already booked, and "Book again" on a past
// session opens that instructor's profile straight on its sessions tab.

// Mirrors the backend `BookingStatus` enum (backend/src/lib/constants.js).
export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

// A pending booking was never paid and a cancelled one never happened, so neither counts.
const BOOKED_STATUSES = new Set([BOOKING_STATUS.CONFIRMED, BOOKING_STATUS.COMPLETED]);

// The tabs on an instructor's profile. The first is where a profile opens by default.
export const PROFILE_TABS = ['about', 'sessions', 'reviews'];
const DEFAULT_PROFILE_TAB = PROFILE_TABS[0];

// The ids of every instructor this student holds a confirmed or completed booking with.
// `bookings` is the list from GET /bookings/my.
export function bookedInstructorIds(bookings) {
  const ids = new Set();
  for (const b of bookings || []) {
    if (b?.instructorId && BOOKED_STATUSES.has(b.status)) ids.add(b.instructorId);
  }
  return ids;
}

// The tab a profile address names (`#/instructor-profile-<slug>?tab=sessions`). The value is
// allow-listed: anything that is not a real tab opens the default one.
export function profileTabFromHash(hash) {
  const text = String(hash ?? '');
  const q = text.indexOf('?');
  if (q === -1) return DEFAULT_PROFILE_TAB;
  const tab = new URLSearchParams(text.slice(q + 1)).get('tab');
  return PROFILE_TABS.includes(tab) ? tab : DEFAULT_PROFILE_TAB;
}

// The page for an instructor's sessions tab, by slug when they have one (TTT-86), else by id.
// Null when there is no instructor to link to.
export function instructorSessionsPage(instructor) {
  const key = instructor?.slug || instructor?.id;
  return key ? `instructor-profile-${key}?tab=sessions` : null;
}

// Where "Book again" on a past booking goes: that booking's instructor, on the sessions tab.
export function rebookPage(booking) {
  return instructorSessionsPage({ slug: booking?.instructor?.slug, id: booking?.instructorId });
}
